<template>
    <div>
        <vs-popup
        class="holamundo"
        icon-close="X"
        :title="this.title"
        :active.sync="active"
        >
        <div class="content">
            <section class="section--sidebar-user">
             
                <section class="section--content-sidebar section--content-sidebar-full-height">
                    <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data" class="workflow-tabs">
                        <div class="tab-content">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                           
                            
                            <div class="row mb-3">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{__("forms.Question.title")}}</label>
                                        <input
                                        type="text"
                                        class="form-control rounded"
                                        name="questionBase[name]"
                                        :value="this.name"
                                        />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{__("forms.Question.description")}}</label>
                                        <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description">
                                    </div>
                                </div>
                                
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{__("forms.Question.sorting")}}</label>
                                        <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                                    </div>
                                </div>
                                
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>Tipologia campo di testo</label>
                                        <div class="form-group">
                                            <label for="questionSettings[type]]_textarea">Textarea</label>
                                            <input type="radio" id="questionSettings[type]]_textarea" name="questionSettings[type]]" value="textarea" v-model="type">
                                            <label for="questionSettings[type]]_input_text">Input text</label>
                                            <input type="radio" id="questionSettings[type]]_input_text" name="questionSettings[type]]" value="input_text" v-model="type">
                                        </div>
                                        
                                        
                                    </div>
                                </div>
                            </div>
                            
                            
                            <div class="row">
                                <div class="col-12">
                                    <hr>
                                </div>
                                <div class="col-12 mt-3 text-right" v-if="can_write">
                                    <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                </div>
                            </div>
                            
                        </div>
                    </form>
                </section>
            </section>
        </div>
    </vs-popup>
</div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            //default
            title: "Comment",
            active : false,
            action : "",
            name:"",
            type:"textarea",
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            this.lang       = attributes.lang;
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                    
                }
                axios.get(dataRoute)
                .then((response) => {
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.type = response.data.type;
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);                                   
                });
            }
        }
        
    }
    
}
</script>

